import React from "react";
import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { Card, Descriptions, Button, Tag } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import { DOCUMENT_TEMPLATE_ONE_QUERY } from "./queries";
import { IDocumentTemplate } from "./interface";

export const DocumentTemplateShow: React.FC = () => {
  const { query } = useShow<IDocumentTemplate>({
    resource: "documentTemplates",
    meta: {
      gqlQuery: DOCUMENT_TEMPLATE_ONE_QUERY,
    },
  });

  const { data, isLoading } = query;
  const record = data?.data;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!record) {
    return <div>Document template not found</div>;
  }

  return (
    <Show title="Document Template Details">
      <Card>
        <Descriptions column={2} layout="vertical" bordered>
          <Descriptions.Item label="Document Name">
            {record.documentName}
          </Descriptions.Item>
          <Descriptions.Item label="Category">
            <Tag color="blue">{record.category}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Tag">
            <Tag color="green">{record.tag}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Template ID">
            {record.templateId}
          </Descriptions.Item>
          <Descriptions.Item label="File ID">
            {record.fileId}
          </Descriptions.Item>
          <Descriptions.Item label="Active">
            <Tag color={record.isActive ? "success" : "error"}>
              {record.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Created By">
            {record.createdBy || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Updated By">
            {record.updatedBy || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {dayjs(record.createdAt).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {dayjs(record.updatedAt).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label="File Download" span={2}>
            {record.url ? (
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                href={record.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download File
              </Button>
            ) : (
              "No file available"
            )}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Show>
  );
};